<div [ngClass]="{'ppl-mt24': source !== 'enrollment'}">
  <nz-card nz-col [nzSpan]="source !== 'enrollment' ? 20 : 24" class="ppl-p24 ppl-step-main" [nzBordered]="false">
    <form nz-form [formGroup]="servicesForm" class="ppl-p0" appAutoFocusFirstInput>
      <nz-row>
        <div nz-col nzSpan="12" nz-flex>
          @if(isAttrAvailable('profLicences')){
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="profLicences"
              class="ppl-form-label">{{getAttributes('profLicences').label}}
              @if(getAttributes('profLicences').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control class="">
              <div nz-tooltip [nzTooltipTitle]="getAttributes('profLicences')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <div [ngClass]="{'error': validationErrors['profLicences'] }">
                  <ppl-multiselect formControlName="profLicences" id="profLicences" [options]="licences" style="width:100%; margin-bottom: 16px"
                    [showClear]="true" placeholder="{{getAttributes('profLicences').placeholder}}" [optionLabel]="'lkpValueName'"
                    [optionValue]="'lkpValueCode'" [disabled]="formReadonly" [maxTagCount]="4" style="width:100%; margin-bottom: 16px">
                  </ppl-multiselect>
                </div>
              </div>
              @if (validationErrors['profLicences']) {
              <span class="pl-1 error-message">{{validationErrors['profLicences']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
          }
        </div>
        <div nz-col nzSpan="12" nz-flex>
          @if(isAttrAvailable('servicesRendered')){
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="servicesRendered"
              class="ppl-form-label">{{getAttributes('servicesRendered').label}}
              @if(getAttributes('servicesRendered').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control class="ppl-form-control">
              <div [ngClass]="{'error': validationErrors['servicesRendered'] }">
                <ppl-multiselect formControlName="servicesRendered" id="servicesRendered" [options]="services" style="width:100%; margin-bottom: 16px"
                  [showClear]="true" placeholder="{{getAttributes('servicesRendered').placeholder}}" [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'" [disabled]="formReadonly" [maxTagCount]="4" style="width:100%; margin-bottom: 16px">
                </ppl-multiselect>
              </div>
              @if (validationErrors['servicesRendered']) {
              <span class="pl-1 error-message">{{validationErrors['servicesRendered']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
          }
        </div>
      </nz-row>
      <nz-row>
        @if(isAttrAvailable('consent')){
          <nz-col [nzSm]="18" [nzXs]="24">
            <ul class="bullet-list" style="padding-left: 20px; margin: 0 0 12px; line-height: 1; list-style-type: disc;">
              <li class="bullet-item" style="margin-bottom: 10px; line-height: 1;">An AR may not be a paid Worker.</li>
              <li class="bullet-item" style="margin-bottom: 0; line-height: 1;">
                An AR must:
                <ul style="padding-left: 22px; margin: 6px 0 0; line-height: 1; list-style-type: circle;">
                  <li style="margin-bottom: 8px; line-height: 1;">Be at least 18 years old,</li>
                  <li style="margin-bottom: 8px; line-height: 1;">Act in the best interest of the Participant,</li>
                  <li style="margin-bottom: 8px; line-height: 1;">Follow the Employer&rsquo;s instructions,</li>
                  <li style="margin-bottom: 8px; line-height: 1;">
                    Maintain regular contact with the:
                    <ul style="padding-left: 22px; margin: 6px 0 0; line-height: 1; list-style-type: square;">
                      <li style="margin-bottom: 8px; line-height: 1;">Employer, and</li>
                      <li style="margin-bottom: 0; line-height: 1;">Participant.</li>
                    </ul>
                  </li>
                  <li style="margin-bottom: 8px; line-height: 1;">
                    Be available to:
                    <ul style="padding-left: 22px; margin: 6px 0 0; line-height: 1; list-style-type: square;">
                      <li style="margin-bottom: 8px; line-height: 1;">The Employer,</li>
                      <li style="margin-bottom: 8px; line-height: 1;">The Participant, and</li>
                      <li style="margin-bottom: 0; line-height: 1;">Program managers.</li>
                    </ul>
                  </li>
                  <li style="margin-bottom: 8px; line-height: 1;">Be willing and able to meet and uphold all program requirements,</li>
                  <li style="margin-bottom: 8px; line-height: 1;">Keep Participant personal information private, and</li>
                  <li style="margin-bottom: 0; line-height: 1;">Submit to background checks.</li>
                </ul>
              </li>
            </ul>
            <nz-form-item class="ppl-form-item">
                <nz-form-control class="ppl-form-control">
                  <input nz-input type="checkbox" class="checkbox" formControlName="consent"/> 
                  <span style="margin-left: 8px; font-weight: 600;">I have read and understand the above rules.</span>
                  <p>
                    <span *ngIf="validationErrors['consent']" class="pl-1 error-message">
                      {{validationErrors['consent']}}
                    </span>
                  </p>
                </nz-form-control>
            </nz-form-item>
          </nz-col>
          }
          </nz-row>

      <!-- @if(isAttrAvailable('filesUploaded')){
        <nz-form-item class="ppl-form-item pt-2">
          <nz-form-label [nzSm]="9">
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <p style="font-size:0.929rem;">Please upload supporting documents</p>
            <ppl-upload (fileSelected)="onFileSelected($event)" (filesUploaded)="filesUploaded($event)"
            (fileRemoved)="onFileRemoved($event)" (downloadRequested)="onDownloadRequested($event)"
            (uploadError)="onUploadError($event)" [fileList]="fileList"
            [docTypeList] = "licences" [flow]="'provider'" [leadId]="''" [showFileList]="true"></ppl-upload>
          </nz-form-control>
        </nz-form-item>
        } -->

    </form>
  </nz-card>
</div>